import { IconButton } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import SettingsIcon from "@material-ui/icons/Settings";
import jwt from "jsonwebtoken";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import logo from "../logo/clarifydata_logo.png";
import { StoreState } from "../store";
import { RoleType } from "../types/index";
import { isFeatureEnabled } from "../utilities";
import TopbarDrawer from "./TopbarDrawer";

interface Props {
  token?: string;
  currentPath: string;
  onLogout: () => void;
}

const useStyles = makeStyles(() => ({
  topbarButton: {
    width: 130,
    color: "white",
  },
  settingsButton: {
    position: "absolute",
    right: 100,
  },
  logoutButton: {
    position: "absolute",
    right: 20,
  },
  linkDashboard: {
    textDecoration: "none",
    color: "inherit",
    width: "100%",
  },
  listItem: {
    padding: 0,
  },
  logo: {
    marginRight: 50,
  },
  "@global": {
    ".MuiBackdrop-root": {
      background: "rgba(0, 0, 0, 0.2)",
    },
  },
}));
const Topbar: React.FC<Props> = (props: Props) => {
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [selectionMenuOpen, setSelectionMenuOpen] = useState(false);
  const [analysisMenuOpen, setAnalysisMenuOpen] = useState(false);
  const settingsItemRef = useRef(null);
  const selectionItemRef = useRef(null);
  const analysisItemRef = useRef(null);
  const token = useSelector((state: StoreState) => state.auth.token);
  const classes = useStyles();
  const location = useLocation();
  const theme = useTheme();

  const userManagement = (token: string | null) => {
    const user = jwt.decode(String(token));
    // tslint:disable-next-line
    const role = user!["role"];

    return role === RoleType.ADMIN
      ? [{ label: "Benutzerverwaltung", path: "/usermanagement" }]
      : [];
  };

  const marketShare = () => {
    return isFeatureEnabled(process.env.REACT_APP_FEATURE_MARKETSHARE)
      ? [{ label: "Marktanteile", path: "/marketshare" }]
      : [];
  };

  const nba = () => {
    return isFeatureEnabled(process.env.REACT_APP_FEATURE_NBA)
      ? [{ label: "Beratungsfokus", path: "/nba-evaluation" }]
      : [];
  };

  const getSelectedStyle = (routes: string[]) => {
    if (routes.includes(location.pathname)) {
      return { color: theme.palette.secondary.light, fontWeight: 600 };
    } else {
      return { color: "white" };
    }
  };
  return (
    <>
      <AppBar>
        <Toolbar>
          <img src={logo} width="150" className={classes.logo} />
          <Button
            className={classes.topbarButton}
            style={getSelectedStyle(["/"])}
          >
            <Link className={classes.linkDashboard} to="/">
              Dashboard
            </Link>
          </Button>
          <Button
            onClick={() => setSelectionMenuOpen(true)}
            className={classes.topbarButton}
            ref={selectionItemRef}
            style={getSelectedStyle(["/customer_selection", "/geoselection"])}
          >
            Selektion
          </Button>
          <Button
            onClick={() => setAnalysisMenuOpen(true)}
            className={classes.topbarButton}
            ref={analysisItemRef}
            style={getSelectedStyle([
              "/effects",
              "/nba-evaluation",
              "/marketshare",
            ])}
          >
            Analyse
          </Button>
          <IconButton
            onClick={() => setSettingsMenuOpen(true)}
            className={classes.settingsButton}
            ref={settingsItemRef}
          >
            <SettingsIcon
              style={getSelectedStyle(["/usermanagement", "/documentation"])}
            />
          </IconButton>

          <Button
            color="inherit"
            className={classes.logoutButton}
            onClick={props.onLogout}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <TopbarDrawer
        open={selectionMenuOpen}
        onClose={() => setSelectionMenuOpen(false)}
        width={180}
        topbarItemRef={selectionItemRef}
        listItems={[
          {
            label: "Kundenselektion",
            path: "/customer_selection",
          },
          {
            label: "Geoselektion",
            path: "/geoselection",
          },
        ]}
      ></TopbarDrawer>
      <TopbarDrawer
        open={analysisMenuOpen}
        onClose={() => setAnalysisMenuOpen(false)}
        width={180}
        topbarItemRef={analysisItemRef}
        listItems={nba()
          .concat([
            {
              label: "Effekte",
              path: "/effects",
            },
          ])
          .concat(marketShare())}
      ></TopbarDrawer>
      <TopbarDrawer
        open={settingsMenuOpen}
        onClose={() => setSettingsMenuOpen(false)}
        width={180}
        topbarItemRef={settingsItemRef}
        listItems={userManagement(token).concat([
          {
            label: "Dokumentation",
            path: "/documentation",
          },
        ])}
      ></TopbarDrawer>
    </>
  );
};

export default Topbar;



// WEBPACK FOOTER //
// ./src/components/Topbar.tsx